<template>
  <div>
    <div class="search flex">
      <span class="tit">新药管理</span>
      <div class="flex">
        <el-button @click="toEdit()" size="mini" class="addBtn">新增药物</el-button>
        <el-input class="addART"
                  placeholder="搜索药品名称" clearable
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>
    </div>
    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">筛选：</span>
        <div class="medicineTypeL">
          <span><label :active="page.status==-1" @click="queryStatus(-1)">全部</label></span>
          <span><label :active="page.status==1" @click="queryStatus(1)">展示中</label></span>
          <span><label :active="page.status==0" @click="queryStatus(0)">未展示</label></span>
        </div>
      </div>
    </div>
    <div class="typeCon">
      <div class="drug flex" v-for="item in page.rows" :key="item.id">
        <div :style="'backgroundImage: url('+item.thumbnailPath+')'" class="img "></div>
        <div class="rightC">
          <h3>{{ item.cnName }}·{{ item.enName }}</h3>
          <p>{{ item.briefDesc }}</p>
          <el-button size="mini" class="danger" plain @click="toEdit(item.id)">编辑</el-button>
          <el-button size="mini" class="danger" plain @click="del(item.id)">删除</el-button>
          <el-button v-if="item.showStatus==1" @click="changeStatus(item,0)" size="small">展示中</el-button>
          <el-button v-else @click="changeStatus(item,1)" size="small">隐藏中</el-button>
        </div>
      </div>
      <div class="noDate flex" v-if="page.rows.length===0">暂无数据</div>
    </div>
    <el-pagination
        class="pagination"
        background
        :hide-on-single-page="true"
        prev-text="Prev"
        next-text="Next"
        @current-change="skipPage"
        :current-page="page.current"
        :page-size="page.size"
        layout="prev, pager, next"
        :total="page.total">
    </el-pagination>
    <!--编辑新增-->
    <el-drawer
        :visible.sync="editDialog.visible"
        :title="(editDialog.mode==='add'?'新增':'编辑')+'药物'"
        :wrapperClosable="false"
        :show-close="false" size="700px" class="drawerCommon" :close-on-press-escape="false">
      <el-form :model="editDialog.form"  label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="中文名">
          <el-input v-model="editDialog.form.cnName"></el-input>
        </el-form-item>
        <el-form-item label="英文名">
          <el-input v-model="editDialog.form.enName"></el-input>
        </el-form-item>
        <el-form-item label="icon">
          <el-upload
              class="avatar-uploader"
              :action="drugThumbnailUrl"
              :show-file-list="false"
              name="uploadFile"
              :on-success="handleThumbnailSuccess">
            <img v-if="editDialog.form.thumbnailPath" :src="editDialog.form.thumbnailPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="显示状态">
          <el-radio v-model="editDialog.form.showStatus" label="1">展示</el-radio>
          <el-radio v-model="editDialog.form.showStatus" label="0">不展示</el-radio>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editDialog.form.showOrder" :min="1" :max="9999" label="显示排序"></el-input-number>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" rows="4" v-model="editDialog.form.briefDesc"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editDialog.form.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button size="small" type="primary" :loading="editDialog.load" @click="save">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "freshDrugManage",
  data() {
    return {
      page: {
        name: '',
        status: -1,
        current: 1,
        size: 10,
        total: 9,
        rows: []
      },
      editDialog: {
        mode: 'add',
        visible: false,
        load: false,
        form: {
          id: '',
          cnName: '',
          enName: '',
          briefDesc: '',
          thumbnailPath: '',
          showStatus: '1',
          showOrder: 1,
          remark: '',
        }
      },
      drugThumbnailUrl: base.uploadUrl + 'drug'
    }
  },
  mounted() {
    this.skipPage(1);
  },
  methods: {
    toEdit(item) {
      let that = this;
      if (item && item.id) { // 编辑
        that.editDialog.form = item;
        that.editDialog.form.showStatus = item.showStatus + '';
        that.editDialog.mode = 'edit';
        that.editDialog.visible = true;
      } else {
        that.editDialog.form = {
          id: '',
          cnName: '',
          enName: '',
          briefDesc: '',
          thumbnailPath: '',
          showStatus: '1',
          showOrder: 1,
          remark: '',
        };
        that.editDialog.mode = 'add';
        that.editDialog.visible = true;
      }
    },
    changeStatus(item, targetStatus) {
      if (item && item.id) {
        let that = this;
        that.$messageBox.confirm('确定要在首页中' + (targetStatus == 1 ? '' : '取消') + '展示吗？', '状态变化提醒', {type: "warning"}).then(_ => {
          that.$ajax.post(base.api.drug.fresh.changeStatus.replace('{id}', item.id).replace('{status}', targetStatus)).then(res => {
            if (res.data.status == 'success') {
              that.$message.success('修改成功');
              item.showStatus = targetStatus;
            } else {
              that.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            that.$message.error('操作失败');
          })
        }).catch(_ => {
        });
      }
    },
    del(id) {
      if (id) {
        let that = this;
        that.$messageBox.confirm('确定要删除吗？', '删除确认', {type: 'warning'}).then(_ => {
          that.$ajax.post(base.api.drug.fresh.del.replace('{id}', id)).then(res => {
            if (res.data.status == 'success') {
              that.$message.success('已删除');
              let index = -1;
              $(that.page.rows).each((i, o) => {
                if (o.id == id) {
                  index = i;
                  return false;
                }
              });
              that.page.rows.splice(index, 1);
            } else {
              that.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            that.$message.error('操作失败');
          })
        }).catch(_ => {
        });
      }
    },
    queryStatus(status) {
      this.page.current = 1;
      this.page.status = status;
      this.skipPage(1);
    },
    skipPage(pageIndex) {
      let that = this;
      that.page.current = pageIndex;
      that.$ajax.get(base.api.drug.fresh.page, {
        params: {
          page: that.page.current,
          size: that.page.size,
          status: that.page.status,
          name: that.page.name
        }
      }).then(res => {
        if (res.data.status == 'success') {
          that.page.current = res.data.current;
          that.page.size = res.data.size;
          that.page.total = res.data.total;
          that.page.rows = res.data.rows;
        }
      }).catch(err => {
        that.$message.error('信息加载失败')
      });
      this.$nextTick(() => {
        $(".el-main").animate({scrollTop: '0px'}, 800);
      });
    },
    handleThumbnailSuccess(res, file) {
      this.editDialog.form.thumbnailPath = res.message;
    },
    save() {
      let that = this;
      if ($.trim(that.editDialog.form.cnName).length === 0) {
        that.$message.warning('药物中文名称不能为空');
        return;
      }
      if ($.trim(that.editDialog.form.enName).length === 0) {
        that.$message.warning('药物英文名称不能为空');
        return;
      }
      let url = '';
      if (that.editDialog.mode === 'add') {
        url = base.api.drug.fresh.add;
      } else if (that.editDialog.mode === 'edit') {
        url = base.api.drug.fresh.edit.replace('{id}', that.editDialog.form.id);
      }
      that.editDialog.load = true;
      that.$ajax.post(url, that.editDialog.form).then(res => {
        if (res.data.status === 'success') {
          that.$message.success('保存成功');
          that.editDialog.visible = false;
          that.skipPage(1);
        } else {
          that.$message.error(res.data.message);
        }
        that.editDialog.load = false;
      }).catch(err => {
        console.error(err);
        that.editDialog.load = false;
        that.$message.error('操作失败');
      });


    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../../assets/css/admin.scss';

.addART {
  margin-left: 20px
}

.typeHead {
  ::v-deep label[active='true'] {
    color: #FFF;
    background: #567BFF;
  }
}

/*.drug-item {
  position: relative;
  margin: 10px 0;
  border-bottom: 1px solid #CCC;
  height: 150px;

  .drug-status {
    position: absolute;
    font-size: 12px;
    color: #FFF;
    width: 40px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    border-radius: 4px;
    transform: scale(0.9);
  }

  .drug-status[active='1'] {
    background: #67C23A
  }

  .drug-status[active='0'] {
    background: #F56C6C
  }

  &:after {
    content: '';
    display: block;
    clear: both;
  }

  .item-img, .item-info {
    float: left;
    box-sizing: border-box
  }

  .item-img {
    width: 20%;
    text-align: center;

    img {
      height: 100%;
      max-height: 120px
    }
  }

  .item-info {
    width: 80%;
    padding: 10px 80px 4px 4px;

    label {
      font-size: 18px;
      font-weight: 700;
    }

    p {
      font-size: 13px;
      color: #666;
      line-height: 1.5rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    .info-title {
      font-weight: 100;
      margin: 4px 0;

      span:first-child {
        font-size: 20px;
        font-weight: 700;
      }

      span {
        margin-right: 14px;
        font-size: 18px;
        font-weight: 400;
      }
    }
  }

  .drug-operate-group {
    position: absolute;
    top: 0;
    right: 10px;
  }
}*/

</style>